import React from "react"

import {
  Container,
  Typography,
} from "@material-ui/core"
import Layout from "../components/Layout"

import Hero from "./../components/Hero"

import { graphql, Link } from "gatsby"

const BlogCards = ({ blogs }) => {
  //   return <div>{JSON.stringify(blogs)}</div>
  return (
    <div>
      <ul className="blog-list">
        {[...blogs].map(blog => {
          const blogText = blog.html.replace(/<[^>]+>/g, "")
          return (
            <Link to={blog.frontmatter.path} className="cloud">
              <div className="text">
                <img
                  className="blog-hero-image"
                  src={blog.frontmatter.hero_image?.publicURL}
                />
               <div className="blog-card-content">
               <Typography variant="body1" component="h1">
                  {blog.frontmatter.title}
                </Typography>
                <Typography variant="caption" className="author">By {blog.frontmatter.author}</Typography>
               </div>
              </div>
            </Link>
          )
        })}
      </ul>
    </div>
  )
}

function Blog({ data }) {
  console.log(data)
  return (
    <Layout
      cssClass="blog-page"
      title="INVIZ AI Solutions | Blogs"
      description="We are a global software and intelligence consultancy company focused on building software, cloud and data solutions with intelligence."
    >
      <Hero>
        <h1>
          <strong>
            <span className="">Thoughts</span>
          </strong>
        </h1>
      </Hero>
      <section>
        <Container>
          <BlogCards
            blogs={data.allMarkdownRemark.edges.map(edge => edge.node)}
          />
        </Container>
      </section>
    </Layout>
  )
}

export const AllBlogsQuery = graphql`
  query AllBlogPosts {
    allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/blog/"}}) {
      edges {
        node {
          frontmatter {
            date
            title
            author
            path
            hero_image {
              publicURL
            }
          }
          html
        }
      }
    }
  }
`

export default Blog
